var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_225_3836",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.314941 0H21.9999V15.6909H0.314941V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_225_3836)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8841 0.256334C16.5998 0.571279 16.6256 1.05779 16.9414 1.34132L19.3013 3.45975H6.48093C3.07675 3.45975 0.317871 6.2113 0.317871 9.60643C0.317871 13.0007 3.07675 15.7531 6.48093 15.7531H16.4956C16.9212 15.7531 17.2661 15.4092 17.2661 14.9847C17.2661 14.5602 16.9212 14.2162 16.4956 14.2162H6.48093C3.928 14.2162 1.85884 12.1526 1.85884 9.60643C1.85884 7.06028 3.928 4.99582 6.48093 4.99582H19.3013L16.9414 7.11425C16.6256 7.39778 16.5998 7.88429 16.8841 8.19924C17.1692 8.51499 17.6562 8.53996 17.9728 8.25643L21.5062 5.08442C22.0166 4.62691 22.0166 3.82867 21.5062 3.37115L17.9728 0.199144C17.6562 -0.0843869 17.1692 -0.0594168 16.8841 0.256334Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.5fcee1bd30e5803c14cba4cd70170a27.svg";
export { ForwardRef as ReactComponent };